/**
 * Created by andrey on 01.07.2020
 */

const ExtraHand = function (game, hand) {
    cleverapps.EventEmitter.call(this);

    this.game = game;
    this.hand = hand;
    this.game.prolongation.on("adsCanceled", this.updateOffer.bind(this), this);

    this.setEnable(cleverapps.user.checkAvailable(cleverapps.config.availables.EXTRA_HAND));
};

ExtraHand.prototype = Object.create(cleverapps.EventEmitter.prototype);
ExtraHand.prototype.constructor = ExtraHand;

ExtraHand.prototype.update = function () {
    this.visible = this.hand.isEmpty() && this.enabled;

    this.offer = this.game.prolongation.getOffer(Prolongation.REWARDS.MOVES);
    this.trigger("update");
};

ExtraHand.prototype.updateOffer = function () {
    this.offer = this.game.prolongation.getOffer(Prolongation.REWARDS.MOVES);
    this.hide();
    this.show();
};

ExtraHand.prototype.show = function () {
    this.visible = true;

    this.trigger("update");
};

ExtraHand.prototype.hide = function () {
    this.visible = false;

    this.trigger("update");
};

ExtraHand.prototype.onCardsClicked = function () {
    if (this.game.counter.isActive()) {
        return;
    }

    cleverapps.tutorial.trigger("clickExtraHand");
    this.game.prolongation.acceptOffer(this.offer);
};

ExtraHand.prototype.setEnable = function (enabled) {
    this.enabled = enabled;
};
